import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductMetafieldFromDescriptionFieldPattern",
    title: "Update Product Metafield From Description Value Pattern",
    description: "Automatically set metafield value based on a value pattern found in the description text of a product.",
    example: null,
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductMetafields",
    dataPermissions: ["products"],
    allowPreview: false,
    tags: ["Products", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductMetafieldFromDescriptionFieldPattern",
                metafieldNamespaceAndKey: null,
                metafieldType: "single_line_text_field",
                prefixPattern: "",
                removeMetafieldValueWhenPatternIsNotFound: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {

                    if (rule.settings.metafieldNamespaceAndKey == null || !/^(.+\..+)$/.test(rule.settings.metafieldNamespaceAndKey)) {
                        errors["metafieldNamespaceAndKey"] = "Incorrect metafield namespace and key";
                    }

                    if (rule.settings.metafieldType == null || rule.settings.metafieldType === "") {
                        errors["metafieldType"] = "Metafield type is required";
                    }

                    if (rule.settings.prefixPattern == null || rule.settings.prefixPattern === "") {
                        errors["prefixPattern"] = "Prefix pattern is required";
                    }
                }
            ], createClashingRulesValidationFunctionNew("PRODUCT"));
    }
};

export default ruleDefinition;